import { getSiteBrand } from "@/lib/siteHosts"

export const LIVE_PROOF_STAMP = "LIVE PROOF"
export const LIVE_PROOF_TAG = "REAL CONVERSATION"

export const LIVE_PROOF_HEADLINE = {
  get lead() {
    return `Watch ${getSiteBrand().name} Digital Brain Qualify & Book a`
  },
  accentPrimary: "$15k Lead",
  leadMid: "in Under",
  accentSecondary: "11 Minutes",
}

export const LIVE_PROOF_SUBHEAD =
  "Real conversation log from a live Home Services deployment. Zero human intervention, instant response times, and automated calendar sync."

export const LIVE_PROOF_PRIVACY_NOTE =
  "Privacy Note: Personal Identifiable Information (PII) like phone numbers and exact addresses have been replaced with mock data."

export const LIVE_PROOF_STATS = [
  { value: "11 min", label: "Lead to booked", sub: "Real deployment timeline" },
  { value: "~11.5s", label: "Avg response", sub: "24/7 availability" },
  { value: "Booked ✓", label: "Site visit", sub: "Synced to calendar" },
]

export const LIVE_PROOF_TIMELINE = [
  { time: "06:58", label: "Lead in" },
  { time: "07:05", label: "Qualified" },
  { time: "07:09", label: "Booked ✓" },
]

export const LIVE_PROOF_LATENCY_BADGE_LIMIT = 3

export const LIVE_PROOF_CHAT_HEADER = {
  label: "LIVE CHAT LOG",
  status: "INSPECTION BOOKED",
}

export const LIVE_PROOF_CHAT_HISTORY = [
  {
    role: "user",
    content:
      "Submitted via landing page form:\n\nHello.\nService that I need: roof_replacement / roof_leak\nMy full name: Jane Doe\nMy phone number: +61400000000\nMy email: jane.doe@example.com\nMy full address: 123 Sample St, Sydney NSW 2000, AU",
    timestamp: "2026-08-05T06:58:39.541303+00:00",
    message_id: "ghl:contact_created:mock_contact_id_0000",
  },
  {
    role: "assistant",
    response_time_seconds: 11,
    content:
      "Hi, I'm Alex from Sample Roofing. So we can prepare a cost estimate or send the right specialist to your property, let's clarify a couple of details. Thanks Jane, got your details. Are you thinking more of a full roof replacement, or an active leak repair?",
    timestamp: "2026-08-05T06:58:50.541303+00:00",
  },
  {
    role: "user",
    content: "Part new roof and an active leak over the living room",
    timestamp: "2026-08-05T07:00:29.400641+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_001",
  },
  {
    role: "assistant",
    response_time_seconds: 14,
    content:
      "What's your ideal timeline for getting this roof started, are you hoping to begin in the next few weeks, a few months, or is it still in the planning phase?",
    timestamp: "2026-08-05T07:00:43.400641+00:00",
  },
  {
    role: "user",
    content: "In next few weeks",
    timestamp: "2026-08-05T07:01:46.532490+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_002",
  },
  {
    role: "assistant",
    response_time_seconds: 9,
    content:
      "Got it, thanks for that. Is this your primary residence, or is it a rental or investment property?",
    timestamp: "2026-08-05T07:01:55.532490+00:00",
  },
  {
    role: "user",
    content: "Primary residence",
    timestamp: "2026-08-05T07:03:53.270897+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_003",
  },
  {
    role: "assistant",
    response_time_seconds: 12,
    content:
      "Thanks for confirming that's your primary residence. Besides yourself, will anyone else be involved in the decision-making, like a spouse or partner? Just so we make sure the right people are included in the inspection.",
    timestamp: "2026-08-05T07:04:05.270897+00:00",
  },
  {
    role: "user",
    content: "Only me",
    timestamp: "2026-08-05T07:04:49.483629+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_004",
  },
  {
    role: "assistant",
    response_time_seconds: 15,
    content:
      "Thanks for clarifying that, Jane. To help us set the right expectations, do you have a rough budget in mind for this roof? It doesn't have to be exact, as we can discuss the details during our inspection.",
    timestamp: "2026-08-05T07:05:04.483629+00:00",
  },
  {
    role: "user",
    content: "No",
    timestamp: "2026-08-05T07:05:28.606544+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_005",
  },
  {
    role: "assistant",
    response_time_seconds: 10,
    content:
      "No worries, we can chat about the budget during the inspection. Have you spoken to any other roofing contractors yet, or are you just getting started with exploring your options?",
    timestamp: "2026-08-05T07:05:38.606544+00:00",
  },
  {
    role: "user",
    content: "I am getting other quotes",
    timestamp: "2026-08-05T07:06:17.692487+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_006",
  },
  {
    role: "assistant",
    response_time_seconds: 13,
    content:
      "Thanks for letting me know, Jane. To help our estimator prepare for the visit, would you be able to share a few photos of the roof? You can email them to info@example.com, or simply attach them here if that's easier.",
    timestamp: "2026-08-05T07:06:30.692487+00:00",
  },
  {
    role: "user",
    content: "Ok",
    timestamp: "2026-08-05T07:06:48.470590+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_007",
  },
  {
    role: "assistant",
    response_time_seconds: 16,
    content:
      "No problem at all, we can work without photos. To get your free inspection booked in, what day and time works best for our estimator to come out this week?",
    timestamp: "2026-08-05T07:07:04.470590+00:00",
  },
  {
    role: "user",
    content: "Anytime after lunch",
    timestamp: "2026-08-05T07:07:43.841950+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_008",
  },
  {
    role: "assistant",
    response_time_seconds: 11,
    content:
      "Got it, I've noted that anytime after lunch works for you. I have availability on Friday 7 August at 1:00 PM, 2:00 PM, or 3:00 PM available for the measure & quote, which of those suits you best?",
    timestamp: "2026-08-05T07:07:54.841950+00:00",
  },
  {
    role: "user",
    content: "Friday at 3pm would be good",
    timestamp: "2026-08-05T07:08:59.276211+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_009",
  },
  {
    role: "assistant",
    response_time_seconds: 10,
    content:
      "All booked, Jane! ✓ Your free inspection is confirmed for Friday, 7 August at 3:00 PM. Our estimator will arrive between 3:00 PM - 5:00 PM, and you'll receive a text reminder before they visit. Is there anything else you need in the meantime?",
    timestamp: "2026-08-05T07:09:09.276211+00:00",
    highlight: true,
  },
  {
    role: "user",
    content: "No thanks",
    timestamp: "2026-08-05T07:09:44.013443+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000:msg_010",
  },
  {
    role: "assistant",
    response_time_seconds: 9,
    content:
      "You're very welcome, Jane! Have a great day and I'm here if you need anything else down the track.",
    timestamp: "2026-08-05T07:09:53.013443+00:00",
  },
]
